<template>
    <div class="contract-list">
        <div class="link-list link-list-2 link-list-long-border" v-if="!loading">
            <!-- <div class="divider bottom-0"></div> -->
            <div class="contract">
                <router-link :to="{name: 'EditInternal'}"> 
                    <!-- dashboard status -->
                    <div v-if="internal.status == 'live'">
                        <i class="fas fa-check color-green2-dark" style="left: -45px"></i>
                        <em class="bg-green2-dark">Live</em>
                    </div>
                    <div v-if="internal.status == 'offline'">
                        <i class="fa fa-pen color-red2-dark" style="left: -45px"></i>
                        <em class="bg-red2-dark">Offiline</em>
                    </div>

                    <span>{{ internal.tab }}</span>
                    <strong></strong>
                    <i class="fa fa-angle-right"></i>
                </router-link>
            </div>
            <div class="contract" v-for="dashboard in dashboards" :key="dashboard.id">
                <router-link :to="{name: 'EditDashboard', params: { dashboard_slug: dashboard.id }}"> 
                    <!-- dashboard status -->
                    <div v-if="dashboard.status == 'live'">
                        <i class="fas fa-check color-green2-dark" style="left: -45px"></i>
                        <em class="bg-green2-dark">Live</em>
                    </div>
                    <div v-if="dashboard.status == 'offline'">
                        <i class="fa fa-pen color-red2-dark" style="left: -45px"></i>
                        <em class="bg-red2-dark">Offiline</em>
                    </div>

                    <span>{{ dashboard.tab }}</span>
                    <strong></strong>
                    <i class="fa fa-angle-right"></i>
                </router-link>
            </div>
        </div>
        <Preloader :feedback="feedback" v-else/>
    </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'

import Preloader from '@/components/layouts/Preloader'

export default {
    name: 'DashboardsList',
    components: {
        Preloader
    },
    data(){
        return{
            dashboards: [],
            internal: {},
            loading: true,
            feedback: null
        }
    },
    mounted(){
        firebase.firestore().collection('dashboards').get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                if(doc.id == 'internal'){
                    this.internal = doc.data()
                } else {
                    let dashboard = doc.data()
                    dashboard.id = doc.id
                    this.dashboards.push(dashboard)
                }
            })
            return true
        }).then(() => {
            this.loading = false
        }).catch(err => {
            this.feedback = err
        })
    },
}
</script>

<style>

</style>